<div>
	<div style="padding-bottom: 1em; font-size: 1.3em">
		<h4>Overview Campaign Data</h4>
	</div>
	<div class="map-overview-stats-widget">
		<table class="rwd-table">
			<tr>
				<th>Product</th>
				<th>Total Imprs</th>
				<th>Total Clicks</th>
				<th>CTR</th>
			</tr>
			<tr *ngFor="let overviewStat of overviewStats; let last = last">
				<td data-th="Product">
					<input
						class="styled-checkbox"
						id="styled-checkbox-{{ overviewStat.productId }}"
						type="checkbox"
						[disabled]="overviewStat.isDisabled"
						[(ngModel)]="overviewStat.productSelected"
						(change)="toggleProductSelection()"
						*ngIf="!overviewStat.isDisabled"
					/>
					<label
						for="styled-checkbox-{{ overviewStat.productId }}"
						[ngClass]="{ 'product-disabled': overviewStat.isDisabled || !overviewStat.productSelected }"
						class="{{ overviewStat.productName }}"
						><span>{{ overviewStat.productName }}</span></label
					>
				</td>
				<td
					data-th="Total Imprs"
					[ngClass]="{ 'disabled-td': overviewStat.isDisabled || !overviewStat.productSelected }"
				>
					{{ overviewStat.productKey === 'email' ? 'n/a' : (overviewStat.impressions | formatNumber) }}
				</td>
				<td
					data-th="Total Clicks"
					[ngClass]="{ 'disabled-td': overviewStat.isDisabled || !overviewStat.productSelected }"
				>
					<span *ngIf="overviewStat.hasClicks; else naBlock">{{ overviewStat.clicks | formatNumber }}</span>
					<ng-template #naBlock>
						<span>n/a</span>
					</ng-template>
				</td>
				<td data-th="CTR" [ngClass]="{ 'disabled-td': overviewStat.isDisabled || !overviewStat.productSelected }">
					<span *ngIf="overviewStat.hasCtr && overviewStat.productKey !== 'email'; else naBlock"
						>{{ overviewStat.ctr | number : '1.2-2' }} %</span
					>
					<ng-template #naBlock>
						<span>n/a</span>
					</ng-template>
				</td>
			</tr>
			<tfoot>
				<td></td>
				<td>{{ getTotalByColumn('impressions') | number }}</td>
				<td>{{ getTotalByColumn('clicks') | number }}</td>
				<td>{{ getTotalCTR() | percent : '1.2-2' }}</td>
			</tfoot>
		</table>
		<table class="rwd-table" *ngIf="youtubeViewsPermission && isR2">
			<tr>
				<th>Product</th>
				<th>YouTube Views</th>
				<th>YouTube View Rate</th>
			</tr>
			<tr *ngFor="let overviewYoutubeStat of overviewYoutubeStats; let last = last">
				<td data-th="Product">
					<input
						class="styled-checkbox"
						id="styled-checkbox-{{ overviewYoutubeStat.productId }}"
						type="checkbox"
						[disabled]="overviewYoutubeStat.isDisabled"
						[(ngModel)]="overviewYoutubeStat.productSelected"
						(change)="toggleProductSelection()"
						*ngIf="!overviewYoutubeStat.isDisabled"
					/>
					<label
						for="styled-checkbox-{{ overviewYoutubeStat.productId }}"
						[ngClass]="{ 'product-disabled': overviewYoutubeStat.isDisabled || !overviewYoutubeStat.productSelected }"
						class="{{ overviewYoutubeStat.productName }}"
						style="margin-right: 3em"
						><span>{{ overviewYoutubeStat.productName }}</span></label
					>
				</td>
				<td
					data-th="YouTube Views"
					[ngClass]="{ 'disabled-td': overviewYoutubeStat.isDisabled || !overviewYoutubeStat.productSelected }"
				>
					{{ overviewYoutubeStat.youtubeViews | formatNumber }}
				</td>
				<td
					data-th="YouTube View Rate"
					[ngClass]="{ 'disabled-td': overviewYoutubeStat.isDisabled || !overviewYoutubeStat.productSelected }"
				>
					<span *ngIf="overviewYoutubeStat.youtubeViewRate; else naBlock"
						>{{ overviewYoutubeStat.youtubeViewRate | number : '1.2-2' }}%</span
					>
					<ng-template #naBlock>
						<span>0.00%</span>
					</ng-template>
				</td>
			</tr>
		</table>
		<div class="no-data-container" *ngIf="!hasData">
			<div style="padding-bottom: 1em; font-size: 1.3em">
				<h4>Overview Campaign Data</h4>
			</div>
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>
</div>
